import React from "react";
import cursosSVG from "../../assets/introduccion/cursos.svg";
import serviciosSVG from "../../assets/introduccion/servicios.svg";
import mainImage from "../../assets/main/fondo_main.jpg"
import { Link } from "react-router-dom";
import "./Introduccion.css"; // Asegúrate de importar el CSS

const Introduccion = () => {
    return (
        <>

            <section className="introduccion-section section-white" style={{ backgroundColor: "white" }}>
                <div className="container">
                    <div className="intro-text-container">
                        <h2 className="title">COPYWRITE PHRASE</h2>
                        <p className="description description-intro">
                            Diseñamos experiencias de aprendizaje que transforman organizaciones.
                            Combinamos estrategia, investigación y creatividad para convertir la formación en un eje real del negocio, alineando personas, procesos y cultura con los desafíos de hoy y del futuro.
                        </p>
                    </div>
                    
                    <div className="contenedor-svgs">
{/* ¿                        <img src={serviciosSVG} alt="Servicios" className="svg-item-introduccion" />
                        <img src={cursosSVG} alt="Cursos" className="svg-item-introduccion" /> */}
                        <Link to="/servicios" style={{ cursor: "pointer" }}  className="svg-item-introduccion">
                            <img src={serviciosSVG} alt="Servicios" />
                        </Link>
            
                        <Link to="/cursos"  className="svg-item-introduccion" style={{ cursor: "pointer" }}>
                            <img src={cursosSVG} alt="Cursos"  />
                        </Link>
                    </div>
                </div>
            </section>
            <div className="container">

                <section className="introduccion-section intro-banner section-green"
                    style={{ backgroundImage: `url(${mainImage})` }} >
                    <p className="description-intro" style={{ color: 'white', maxWidth: '1000px' }}>
                    Nuestros programas son modelos concretos de cómo el aprendizaje puede convertirse en ventaja competitiva: traducimos la estrategia en competencias, experiencias y herramientas que desarrollan talento, fortalecen el liderazgo y facilitan procesos de transformación organizacional, desde la operación hasta la alta dirección.
                    </p>

                </section>
            </div>


        </>

    );
};

export default Introduccion;